export default "__VITE_ASSET__BpPmEci3__"